import { render, staticRenderFns } from "./CalendarData.vue?vue&type=template&id=a368aac2&scoped=true"
import script from "./CalendarData.vue?vue&type=script&lang=js"
export * from "./CalendarData.vue?vue&type=script&lang=js"
import style0 from "./CalendarData.vue?vue&type=style&index=0&id=a368aac2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a368aac2",
  null
  
)

export default component.exports